import { HttpHeaders } from '@angular/common/http';

export class HttpHelper {
  public static setHeaders(): HttpHeaders {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    return headers;
  }
}
